<template>
  <VGrid class="v-form-blueprint" :gap="15">
    <VCol v-if="blueprint.settings.showSectionsSidebar" :md="7">
      <slot name="sidebar">
        <VFormBuilderSections :blueprint />
      </slot>
    </VCol>

    <VCol :md="blueprint.settings.showSectionsSidebar ? 17 : 24">
      <Transition mode="out-in" name="v-fade-fast">
        <VCard :key="blueprint.activeSection.id" :title="blueprint.activeSection.title">
          <div class="v-form-blueprint__description">{{ blueprint.activeSection.description }}</div>

          <VFormBlueprintQuestion v-for="question in blueprint.visibleQuestions" :key="question.id" :blueprint :question @updated="emit('updated', $event)">
            <template #answer="slotProps">
              <slot name="answer" v-bind="slotProps" />
            </template>
            <template #after-question-answer="slotProps">
              <slot name="after-question-answer" v-bind="slotProps" />
            </template>
            <template #file-name="slotProps">
              <slot name="file-name" v-bind="slotProps" />
            </template>
          </VFormBlueprintQuestion>
        </VCard>
      </Transition>
    </VCol>
  </VGrid>
</template>

<script setup lang="ts">
import { type FileLike } from '../types.ts'
import { type Blueprint, type Question } from './FormBuilder/useBlueprint.ts'
import VFormBuilderSections from './FormBuilder/VFormBuilderSections.vue'
import VCard from './VCard.vue'
import VCol from './VCol.vue'
import VFormBlueprintQuestion from './VFormBlueprintQuestion.vue'
import VGrid from './VGrid.vue'

interface Props {
  blueprint: Blueprint
}

defineProps<Props>()

defineSlots<{
  sidebar(): any
  answer(props: { question: Question }): any
  'after-question-answer'(props: { question: Question }): any
  'file-name'(props: { file: FileLike; index: number; question: Question }): any
}>()

const emit = defineEmits<{
  updated: [Question]
}>()
</script>

<style>
.v-form-blueprint__description {
  color: var(--color-grey-40);
  padding-bottom: 20px;
}
</style>
